module.exports = __webpack_public_path__ + "img/MQ-UNF.fa310736.svg";